var exports = {
  "CS": "x4c3adb35--ccd5e8--loupe",
  "IU": "x4c3adb35--ccd5e8--clear",
  "eU": "x4c3adb35--ccd5e8--clear-icon",
};

module.exports = exports;
